import { combineReducers } from "redux";
import { all } from "redux-saga/effects";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import * as app from "./appRedux";
import * as calculation from "./calculationRedux";
import * as resetPassword from "./resetPasswordRedux";
import * as subscription from "./subscriptionRedux";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  app: app.reducer,
  subscription: subscription.reducer,
  calculation: calculation.reducer,
  resetPassword: resetPassword.reducer
});

export function* rootSaga() {
  yield all([
    auth.saga(),
    app.saga(),
    subscription.saga(),
    calculation.saga(),
    resetPassword.saga()
  ]);
}
